/**
 * P12.4 — PendingReviewBlock
 *
 * Shown to installers/contractors when they hit a job that hasn't been
 * approved by Ops/PM yet. SuperAdmin observers see the same block but with
 * the existing ObserverBanner above it (handled by the parent surface).
 */

import { Card, CardContent } from "@/components/ui/card";
import { ClipboardList } from "lucide-react";

export function PendingReviewBlock({ jobId }: { jobId?: string }) {
  return (
    <Card
      data-testid="installer-pending-review"
      data-job-id={jobId}
      className="border-warning/40 bg-warning/[0.05]"
    >
      <CardContent className="p-5 text-center space-y-2">
        <div className="mx-auto h-9 w-9 rounded-lg bg-warning/15 text-warning border border-warning/30 flex items-center justify-center">
          <ClipboardList className="h-4 w-4" />
        </div>
        <p className="text-sm font-semibold">This job is pending project review.</p>
        <p className="text-xs text-muted-foreground leading-snug">
          Your PM will release it once the plan is approved. You'll get
          access to materials, photos, and the execution checklist as soon
          as it's ready.
        </p>
      </CardContent>
    </Card>
  );
}

export default PendingReviewBlock;
